import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
function Client() {
  let navigate = useNavigate();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [client, setClient] = useState({
    name: "",
    designation: "",
    description: "",
    images: "",
  });

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;

    setClient({ ...client, [name]: value });
  };
  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setClient({ ...client, [name]: e.target.files[0] });
  };
  const PostData = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", client.name);
    formData.append("designation", client.designation);
    formData.append("description", client.description);
    formData.append("clientImage", client.images);
    axios
      .post("https://api.homedotapp.com/api/client", formData, {})
      .then((res) => {
        if (res.status === 422 || !res) {
          window.alert("error");
        } else {
          window.alert("Added New Client");
        }
      });
  };
  return (
    <div>
      <div className="container-scroller">
        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />

          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Client</h4>
                      <p className="card-description">Add New Client</p>
                      <form className="forms-sample" onSubmit={PostData}>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Name"
                            name="name"
                            value={client.name}
                            onChange={handleInputs}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Designation
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Designation"
                            name="designation"
                            value={client.designation}
                            onChange={handleInputs}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Description
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Description"
                            name="description"
                            value={client.description}
                            onChange={handleInputs}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Image</label>
                          <br></br>
                          <input
                            type="file"
                            name="images"
                            onChange={onFileChange}
                          />
                        </div>
                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Client;
